import { Parallax } from "react-parallax";
import parallaxImg from "../../assets/parallax_L1180240.jpg";

const ParallaxBanner = () => {
  return (
    <Parallax
      blur={0}
      bgImage={parallaxImg}
      bgImageAlt="the cat"
      strength={200}
    >
      <div className="parallax__caption">
        <div className="container">
          <div className="parallax__content">
            <h1 style={{textAlign: 'center'}}>
            I tuoi progetti immobiliari<br />chiavi in mano
            </h1>
          </div>
        </div>
      </div>
    </Parallax>
  );
};

export default ParallaxBanner;
